import { Supplier } from './supplier';

export class DropAmtComnt {
        DropID!: Number;
        SupplierAB!: Number;
        ObjectAccount!: string;
        DropAmt ! : number;
        DropComments ! : string;
        CreatedDate! : string;
        CreatedBy!: string;
        UpdatedDate!: Date;
        UpdatedBy!: string;
         SupName!:string;
         Period!:string
         FromDate! :string;
         ToDate! :string;
         Remarks! : string;
         Area?: string;
}
